import { el } from "./dom.js";

// Toolbar control that flips a category list between two views of its
// collections:
//   • Grouped (default) — each group shows as a single group card/tile that
//     stands in for its members (members are collapsed out of the flat list).
//   • Ungrouped — groups are dissolved, so every member shows as its own item
//     inline in the list, sorted/filtered like any other item.
//
// State lives in the caller (so it persists in the view's module-level `state`
// alongside the sort); this just renders the button and reports flips via
// `onChange(expanded)`. Returns the button element so the caller can place it
// in the toolbar and toggle its visibility (hide it when the category has no
// groups to dissolve).
export function groupToggle({ expanded = false, onChange }) {
	let state = expanded;
	const button = el("button.btn.btn--small.group-toggle", {
		type: "button",
		title: "Switch between showing collections as groups or expanding them into individual items",
	});

	function paint() {
		// The label shows the current view; tapping flips it.
		button.textContent = state ? "▦ Ungrouped" : "⊞ Grouped";
		button.setAttribute("aria-pressed", state ? "true" : "false");
	}

	button.onclick = () => {
		state = !state;
		paint();
		onChange(state);
	};

	paint();
	return button;
}
